import useAxiosService from './useAxiosService'
import { IPrescriptionDetail } from 'interfaces'
import { IResponse } from 'interfaces/services'
import {
  ICreatePrescriptions,
  ICreateSubclinical,
  IGetSubclinicalQuery,
  IHealthRecord,
  ISubclinical
} from 'pages/exam/interfaces'
import { IHistoryBooking } from 'pages/patientBooking/interfaces'
import {
  IAddSubServicesQuery,
  IBookingDetail
} from 'pages/patientReceive/interfaces'
import { IInventoryQuerySearch } from 'pages/repoInventory/interfaces'

const useExamService = () => {
  const { get, patch, dele, post } = useAxiosService()

  const getPatientBookings = async (patientId: number) => {
    const res = get(`/clinic/booking/patient/${patientId}`)
    return res as Promise<IResponse<Array<IHistoryBooking>>>
  }

  const createUpdateHealthRecord = async (query: IHealthRecord) => {
    const res = patch(`clinic/health-record/update`, query)
    return res as Promise<IResponse<any>>
  }
  const removeSubServiceToBooking = async (query: IAddSubServicesQuery) => {
    const response: any = await dele(
      '/clinic/booking/delete-sub-service',
      query
    )
    return response as IResponse<IBookingDetail>
  }

  const addSubServiceToBooking = async (query: IAddSubServicesQuery) => {
    const response: any = await post('/clinic/booking/add-sub-service', query)
    return response as IResponse<IBookingDetail>
  }

  const createSubclinical = async (query: ICreateSubclinical) => {
    const response: any = await post('/clinic/subclinical', query)
    return response as IResponse<any>
  }

  const getSubclinical = async (query: IGetSubclinicalQuery) => {
    const response: any = await post('/clinic/subclinicals', query)
    return response as IResponse<{ subclinicals: Array<ISubclinical> }>
  }

  const deleteSubclinical = async (id: number) => {
    const response: any = await dele(`/clinic/subclinical/${id}`)
    return response as IResponse<any>
  }

  const searchMedicine = async (query: IInventoryQuerySearch) => {
    const response: any = await post(`/clinic/medicines/search`, query)
    return response as IResponse<any>
  }

  const createPrescriptions = async (query: ICreatePrescriptions) => {
    const response: any = await post(`/clinic/prescription`, query)
    return response as IResponse<any>
  }

  const inquiryPrescriptions = async (query: ICreatePrescriptions) => {
    const response: any = await post(`/clinic/prescription/inquiry`, query)
    return response as IResponse<any>
  }

  const getPrescriptionDetail = async (bookingId: number) => {
    const response: any = await get(`/clinic/prescription/${bookingId}`)
    return response as IResponse<IPrescriptionDetail>
  }

  const getPrescriptionByPatientId = async (id: number) => {
    const response: any = await post(`clinic/prescription/search`, {
      query: {
        patient_id: id
      }
    })
    return response as IResponse<any>
  }
  return {
    getPatientBookings,
    createUpdateHealthRecord,
    removeSubServiceToBooking,
    addSubServiceToBooking,
    createSubclinical,
    getSubclinical,
    deleteSubclinical,
    searchMedicine,
    createPrescriptions,
    getPrescriptionDetail,
    inquiryPrescriptions,
    getPrescriptionByPatientId
  }
}
export default useExamService
